const Colors = {
  primary: '#4A7C9B',
  primaryDark: '#34566F',
  primaryLight: '#E8F1F7',
  secondary: '#7FA99B',
  background: '#F7F9FA',
  surface: '#FFFFFF',
  text: '#2C3E50',
  textSecondary: '#6B7C8C',
  border: '#E1E8ED',
  accent: '#C19A6B',
  error: '#D35D5D',
  errorLight: '#FDE8E8',
  success: '#7FA99B',
  successLight: '#E8F5F1',
  ice: '#B8D4E8',
  volcanic: '#4A4A4A',
};

export default Colors;
